// NEEDS TO BE CONFIGURED

module.exports = {
  serverApi: 'https://smartdine.sylada.com/api',
  stripe: {
    publishableKey: 'pk_test_G207OTkFBXuKr4b5ct3I33xn',
    clientId: 'ca_EZPFIjlLKPF1g1a4FbTn816BzaLNOMlQ',
    redirectUri: 'https://smartdine.sylada.com/stripe/connect/response'
  },
  ikentoo: {
    trialCodeLink: 'https://nightswatch-trial.ikentoo.com/oauth/authorize?client_id=smartdinedevtrial-9ad2-4403-a43c-827cda86efb1&response_type=code&redirect_uri=https://pastab.smartdine.ch/ikentoo',
    productionCodeLink: 'https://nightswatch.ikentoo.com/oauth/authorize?client_id=smartdine-62bf-4466-9ed7-aa92bdd36bd8&response_type=code&redirect_uri=https://pastab.smartdine.ch/ikentoo'
  },
  allLangCourseOptions: [
    {
      lang: 'en',
      options: [
        { value: 1, text: 'Serve now' },
        { value: 2, text: 'Starter' },
        { value: 3, text: 'Main Course' },
        { value: 4, text: 'Dessert' }
      ]
    },
    {
      lang: 'it',
      options: [
        { value: 1, text: 'Servire ora' },
        { value: 2, text: 'Antipasto' },
        { value: 3, text: 'Portata principale' },
        { value: 4, text: 'Dolce' }
      ]
    },
    {
      lang: 'jp',
      options: [
        { value: 1, text: '今サーブ' },
        { value: 2, text: 'スターター' },
        { value: 3, text: 'メインコース' },
        { value: 4, text: 'デザート' }
      ]
    },
    {
      lang: 'zh',
      options: [
        { value: 1, text: '现在服务' },
        { value: 2, text: '起动机' },
        { value: 3, text: '主菜' },
        { value: 4, text: '甜点' }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/config/config.js